/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Connect_ShortInputs */



/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Voice_Manager_Elevenlabs_Connect_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_connect_short = /** @type {((inputs?: Voice_Manager_Elevenlabs_Connect_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Connect_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connecter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connetti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conectar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("连接")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接続")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनेक्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ligar")
	return /** @type {LocalizedString} */ ("Connect")
});